<template lang="pug">
    .md-content
        PmBreadcrumbs(:view="lenguageSelected.breadcrumb", :section="section", :lang="lenguage")
        PmBanner(:name="lenguageNavSelected.title", :image="banner")
        .container
            .navbar-publications
                .navbar-option-publications.active Perú
                .navbar-option-publications Chile
                .navbar-option-publications Colombia
                .navbar-option-publications Ecuador 
        .container
            .row
                .col-lg-4.custom-fix-padding
                    .publications-content {{ lenguageSelected.content }}
                    .publications-date
                        .publications-date-name {{ lenguageSelected.dateTitle }}:
                        .publications-date-content {{ lenguageSelected.date }}
                    .publications-author
                        .publications-date-name  {{ lenguageSelected.authorTitle }}:
                        .publications-date-content {{ lenguageSelected.author }}
                    // .publications-hr
                    // a.publications-button(:href="pdfSource", download="CÓDIGO DE BUENAS PRÁCTICAS (FIRMADO POR MIEMBROS)") {{ lenguageSelected.button }}
                .col-lg-8.section2-publications
                    .pdf-padding
                        .pdf-container
                            .pdf-header
                                .publications-icon(v-if="currentPage != 1")
                                    svg(@click="changePage('minus')", stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.8em" width="1.8em" xmlns="http://www.w3.org/2000/svg")
                                        path(d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z")
                                .publications-icon.hidde-icon(v-if="currentPage == 1")
                                    svg(stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.8em" width="1.8em" xmlns="http://www.w3.org/2000/svg")
                                        path(d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z")
                                .publications-pages {{currentPage}} / {{pageCount}}
                                .publications-icon(v-if="currentPage != pageCount")
                                    svg(@click="changePage('plus')", stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.8em" width="1.8em" xmlns="http://www.w3.org/2000/svg")
                                        path(d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z")
                                .publications-icon.hidde-icon(v-if="currentPage == pageCount")
                                        svg(stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1.8em" width="1.8em" xmlns="http://www.w3.org/2000/svg")
                                            path(d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z")
                            pdf(:src="pdfSource", :page="pdfPage", @num-pages="pageCount = $event", @page-loaded="currentPage = $event")
        .container
            .publications-hr-2
            .publications-hr-3

</template>

<script>
import PmBreadcrumbs from '@components/atoms/PmBreadCrumbs.vue'
import PmBanner from '@components/atoms/PmBanner.vue'
import PmContentBox from '@components/atoms/PmContentBox.vue'
import PmSidebar from '@components/atoms/PmSidebar.vue'
import VueRecaptcha from 'vue-recaptcha';
import pdf from 'vue-pdf'

import publicationsBanner from '@img/publications/Banner_publications.jpg'
import pdfView from '@pdf/CÓDIGO DE BUENAS PRÁCTICAS (FIRMADO POR MIEMBROS).pdf'

import axios from 'axios'

import { isEmpty } from 'lodash'

export default {
    props: ["lang"],
    created: function(){
        this.$data.lenguage = this.lang;
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    components: {
        PmBreadcrumbs, PmBanner, PmContentBox, PmSidebar, VueRecaptcha, pdf
    },
    mounted: function(){
        this.$data.section = this.$route.name;
        let to = this.moveToDown
        ? this.$refs.description.offsetTop - 60
        : 0

    window.scroll({
        top: to,
        left: 0,
        behavior: 'smooth'
    })

    this.moveToDown = !this.moveToDown
    },

    methods: {
        handleResize() {
            this.$data.window.width = window.innerWidth;
            this.$data.window.height = window.innerHeight;
        },
        changePage(action){
            if(action == 'plus') this.$data.pdfPage = this.$data.pdfPage + 1
            else this.$data.pdfPage = this.$data.pdfPage - 1
        }
    },

    data: function(){
        return{
            pdfPage: 1,
            currentPage: 0,
            pageCount: 0,
            pdfSource: pdfView,
            sendState: 'normal',
            isactivated: false,
            window: {
            width: 0,
            height: 0
            },
            form: {
                form_departments: [],
                form_country: "",
                data: [],
                data2: [],
                message: ''
            },

            error: {
                form_departments: false,
                form_country: false,
                data: [],
                data2: [],
                message: false
            },


            banner: publicationsBanner,
            section: '',
            enContent: {
                title: 'PUBLICATIONS',
            },
            esContent: {
                title: 'PUBLICACIONES',
            },

            lenguage: 'ES',
            lenguageEN: {
                breadcrumb: {name:'Publications', link:'/en/publications'},
                content: '"CÓDIGO DE BUENAS PRÁCTICAS PARA EL DESPLIEGUE DE INFRAESTRUCTURA NECESARIA PARA BRINDAR EL SERVICIO PÚBLICO DE TELECOMUNICACIONES"',
                dateTitle: 'Fecha',
                date: '17/06/2020',
                authorTitle: 'Autor',
                author: 'ATP',
                button: 'Descargar PDF'
            },

            lenguageES: {
                breadcrumb: {name:'Publicaciones', link:'/es/publicaciones'},
                content: '"CÓDIGO DE BUENAS PRÁCTICAS PARA EL DESPLIEGUE DE INFRAESTRUCTURA NECESARIA PARA BRINDAR EL SERVICIO PÚBLICO DE TELECOMUNICACIONES"',
                dateTitle: 'Fecha',
                date: '17/06/2020',
                authorTitle: 'Autor',
                author: 'ATP',
                button: 'Descargar PDF'
            },
        }
    },
    computed: {
        lenguageSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.lenguageEN : this.$data.lenguageES
        },
        lenguageNavSelected: function(){
            return this.$data.lenguage == 'EN'? this.$data.enContent : this.$data.esContent
        }
    },
}
</script>

<style lang="scss" scoped>
    .error{
        color: red;
        font-size: 11px;
    }
    .navbar-publications{
        margin-top: 30px;
        margin-bottom: 30px;
        border-bottom: 2px solid #d91222;
    }
    .navbar-option-publications{
        position: relative;
        display: inline-block;
        padding: 5px;
        width: 180px;
        text-align: center;
        margin-right: 30px;
        font-size: 18px;
        color: #d91222;
        @media (max-width: 768px) {
            width: 100px;
            margin-right: 10px;
        }
        &.active{
            background-color: #d91222;
            color: white;
            &::after{
                content: '';
                position: absolute;
                width: 0;
                height: 0;
                border-bottom: 43px solid #d91222;
                border-right: 24px solid transparent;
                bottom: 0px;
                right: -24px;
            }
        }
    }
    .publications-content{
        color: #073a74;
        font-size: 25px;
        font-weight: 600;
        line-height: 140%;
        margin-bottom: 20px;
    }
    .publications-date-name{
        display: inline-block;
        color: #868686;
        margin-right: 10px;
        font-size: 16px;
        line-height: 100%;
    }
    .publications-date-content{
        display: inline-block;
        line-height: 100%;
    }
    .publications-hr{
        border-bottom: 1px dashed #868686;
        margin: 10px 0px;
    }
    .publications-button{
        display: block;
        width: 100%;
        padding: 6px 20px;
        border-radius: 7px;
        background-color: #868686;
        color: white;
        font-weight: normal;
        margin-top: 20px;
        font-size: 18px;
        cursor: pointer;
        transition: all .3s;
        text-align: center;
        &:hover{
            color:white!important
        }
    }
    .custom-fix-padding{
        padding-right: 62px;
        @media (max-width: 992px) {
            padding-right: 0px;
            margin-bottom: 80px;
        }
    }
    .pdf-container{
        position: relative;
        padding: 50px;
        padding-top: 70px;
        background-color: #525659;
    }
    .pdf-header{
        position: absolute;
        background-color: #313439;
        padding: 10px 0px;
        text-align: center;
        color: white;
        width: 100%;
        top: 0px;
        left: 0px;
        z-index: 100;
    }
    .publications-pages{
        margin: 0px 20px;
    }
    .publications-icon, .publications-pages{
        display: inline-block;
    }
    .publications-icon{
        cursor: pointer;
    }
    .publications-icon.hidde-icon{
        opacity: .3;
        cursor: not-allowed;
    }
    .publications-hr-2{
        margin-top: 40px;
        margin-bottom: 5px;
        border-bottom: 4px solid #073a74;
    }
    .publications-hr-3{
        margin-bottom: 80px;
        border-bottom: 17px solid #D8D8D8;
    }
</style>




// WEBPACK FOOTER //
// src/components/organisms/PmPublications.vue